import React, {Component} from 'react';

import '../../sass/faqitem.scss';
import FaqQuestion from '../faq/FaqQuestion';

class FaqItem extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }
    toggleShow() {
        (this.state.show) ? this.setState({show: false}) : this.setState({show: true});
    }
    render()
    {
        const { data } = this.props;
        const {show} = this.state;
        let nameClass = 'name-item';
        if (show) nameClass = 'name-item active';

        var listQuestions = [];

        for (let i=0; i<data.QA.length;i++) {
            listQuestions.push(<FaqQuestion key={i} data={data.QA[i]} />);
        }


        return (
            <div className="item-faq">
                {/*<div className={nameClass} onClick={(e)=>{this.toggleShow()}}>{data.name}</div>*/}
                <div className="info-item">
                    {listQuestions}
                </div>
            </div>
        )
    }
}

export default FaqItem;







// WEBPACK FOOTER //
// ./src/components/faq/FaqItem.js